import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { NgForage } from 'ngforage';
import AssetHelper from 'src/app/helpers/asset-helper';
import { User } from 'src/app/model/user';
import { SnackService } from 'src/app/services/snack.service';
import { MAX_UPLOAD_SIZE } from 'src/globals/globals';
import { OfflineProfilePicture } from '../helper/offline-profile-picture';
import { v4 as uuidv4 } from 'uuid';
import { DomSanitizer } from '@angular/platform-browser';
import { FileUploader } from 'ng2-file-upload';
import { FileHelper } from '../../../../helpers/file-helper';

@Component({
  selector: 'employee-profile-picture',
  templateUrl: './employee-profile-picture.component.html',
  styleUrls: ['./employee-profile-picture.component.scss'],
})
export class EmployeeProfilePictureComponent implements OnDestroy {
  @Input()
  user: User;
  @Output()
  offlineProfilePictureSet = new EventEmitter<OfflineProfilePicture>();

  uploader: FileUploader = new FileUploader({
    allowedMimeType: ['image/jpeg', 'image/png'],
    allowedFileType: ['jpg', 'jpeg', 'png'],
    url: '',
  });

  offlineProfilePicture: OfflineProfilePicture;
  objectUrl: string;
  isImage = FileHelper.isImage;

  constructor(
    private ngForage: NgForage,
    private snackService: SnackService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnDestroy(): void {
    this.deleteOfflineProfilePicture();
    if (this.objectUrl != null) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }

  private async deleteOfflineProfilePicture(): Promise<void> {
    if (this.offlineProfilePicture != null) {
      this.ngForage.removeItem(
        AssetHelper.getStorageKeyFor(this.offlineProfilePicture.localFileUuid)
      );
      this.offlineProfilePicture = null;
    }
  }

  async setOfflineProfilePicture(fileList: FileList): Promise<void> {
    if (fileList == null || fileList.length === 0) {
      return;
    }

    const file = fileList.item(0);

    if (file.size > MAX_UPLOAD_SIZE) {
      this.snackService.showError(
        'Gelieve enkel bestanden kleiner dan 8 MB te seleceren'
      );
      return;
    }

    const result = await this.createOfflineProfilePicture(file);
    await this.deleteOfflineProfilePicture();
    if (this.objectUrl != null) {
      URL.revokeObjectURL(this.objectUrl);
    }
    this.objectUrl = result.objectURL;
    this.offlineProfilePicture = result.offlineProfilePicture;
    this.offlineProfilePictureSet.next(this.offlineProfilePicture);
  }

  private async createOfflineProfilePicture(
    file: File
  ): Promise<CreateOfflineProfilePictureResult> {
    const uuid = uuidv4();
    await this.ngForage.setItem(AssetHelper.getStorageKeyFor(uuid), file);
    const blobUrl = URL.createObjectURL(file);
    return {
      offlineProfilePicture: new OfflineProfilePicture(
        file.name,
        file.type,
        file.size,
        uuid,
        this.sanitizer.bypassSecurityTrustUrl(blobUrl)
      ),
      objectURL: blobUrl,
    };
  }
}

interface CreateOfflineProfilePictureResult {
  offlineProfilePicture: OfflineProfilePicture;
  objectURL: string;
}
